import { render, staticRenderFns } from "./responsible_unit.vue?vue&type=template&id=2602f6ba&scoped=true"
import script from "./responsible_unit.vue?vue&type=script&lang=js"
export * from "./responsible_unit.vue?vue&type=script&lang=js"
import style0 from "./responsible_unit.vue?vue&type=style&index=0&id=2602f6ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2602f6ba",
  null
  
)

export default component.exports